export default __webpack_public_path__ + "static/sentrydefault_120x68-7f55e90216af05b1792bb472acba34f4.jpg";